const UNLOCK_ACCOUNT_GATE = 'unlock-account-gate'

export const BACKDROP = `${UNLOCK_ACCOUNT_GATE}-modal-backdrop`
export const MODAL_CONTENT = `${UNLOCK_ACCOUNT_GATE}-modal-content`
export const CLOSE_BUTTON = `${UNLOCK_ACCOUNT_GATE}-close-button`
export const TITLE_ICON = `${UNLOCK_ACCOUNT_GATE}-title-icon`
export const TITLE_TEXT = `${UNLOCK_ACCOUNT_GATE}-title-text`
export const CREATE_ACCOUNT_BUTTON = `${UNLOCK_ACCOUNT_GATE}-create-acount-button`
export const UNLOCK_LINK = `${UNLOCK_ACCOUNT_GATE}-unlock-link`
export const LOGIN_BANNER = `${UNLOCK_ACCOUNT_GATE}-login-banner`
export const LOGIN_LINK = `${UNLOCK_ACCOUNT_GATE}-login-link`
